import { render, staticRenderFns } from "./EditCurve.vue?vue&type=template&id=3b2fd358"
import script from "./EditCurve.vue?vue&type=script&lang=ts"
export * from "./EditCurve.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports